import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { BrowserStorage } from '../utils/browserStorage';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  const token = isBrowser ? BrowserStorage.get('userToken') : null;

  if (!token) {
    if (isBrowser) {
      router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
    }
    return false;
  }

  return true;
};
